import React from 'react';
const idealFor = [{
  emoji: '👩‍🏫',
  label: 'Docentes de secundaria'
}, {
  emoji: '📚',
  label: 'Profesores de distintas materias'
}, {
  emoji: '🧑‍🏫',
  label: 'Preceptores y tutores'
}, {
  emoji: '🏫',
  label: 'Equipos de orientación y acompañamiento'
}, {
  emoji: '📖',
  label: 'Talleres y espacios institucionales'
}, {
  emoji: '🏠',
  label: 'Familias que acompañan estudiantes'
}];
export function BeforeAfterSection() {
  return <section className="py-8 px-4 bg-gray-50" data-id="element-26" data-mp="zk58qkuts9b3">
      <div className="max-w-5xl mx-auto" data-id="element-27" data-mp="unetfzquhhqq">
        <h2 className="text-[20px] font-black mb-2 text-center text-[#1B3A6B]" data-id="element-28" data-mp="umdj5xhnkza2">
          IDEAL PARA:
        </h2>

        <p className="text-center text-gray-600 mb-6 text-base md:text-lg max-w-2xl mx-auto" data-id="element-29" data-mp="18kk4ke5f16su">
          Un material pensado para quienes acompañan adolescentes desde
          distintos lugares.
        </p>

        <div className="grid grid-cols-2 md:grid-cols-3 gap-4" data-id="element-30" data-mp="3afuigw08ypv2">
          {idealFor.map((item, index) => <div key={index} className="bg-white rounded-2xl p-5 shadow-md border border-gray-100 flex flex-col items-center text-center" data-id="element-31" data-mp="35haw4uhqrc26" data-mpi={index}>
              <span className="text-5xl mb-3" data-id="element-32" data-mp="3bmth3tefo33y">{item.emoji}</span>
              <p className="text-base md:text-lg font-bold text-gray-800" data-id="element-33" data-mp="3bla2e78fe04a">
                {item.label}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}